import { useEffect, useRef, useState } from "react";
import style from './Navbar.module.css';
import { Link } from "react-router-dom";
import Switch from "react-switch";
import '../style.css';

const Navbar = ({refs}) => {
    const [theme, setTheme] = useState('dark');
    const [showTooltip, setShowTooltip] = useState(false);
    const [showWarningModal, setShowWarningModal] = useState(false);

    const scrollTo = (refName) => {
        window.scrollTo({ top: refs[refName].current.offsetTop, behavior: 'smooth' });
    }

    const themeSwitch = () => {
        if (theme === 'dark') {
            setShowWarningModal(true);
        } else {
            setTheme('dark');
        }
    };

    const confirmLightMode = () => {
        setShowWarningModal(false);
        setTheme('light');
    };

    const cancelLightMode = () => {
        setShowWarningModal(false);
    };

    let prevScroll = useRef(0);
    useEffect (() => {
        const handleScroll = () => {
            const curScroll = window.scrollY;
            if ((curScroll - prevScroll.current) >= 20) {
                    document.getElementsByClassName(style.nav)[0].classList.add(style.close);    
            } else if ((curScroll - prevScroll.current) <= -1 ){
                    document.getElementsByClassName(style.nav)[0].classList.remove(style.close);
                    document.getElementsByClassName(style.nav)[0].style.display = "flex";  
            }
            prevScroll.current = curScroll;
        };
        window.addEventListener("scroll", handleScroll);
        document.documentElement.classList.remove('light', 'dark');
        document.documentElement.classList.add(`${theme}`);
    }, [theme]);

    return (
        <>
            <div className={`${style.nav} nav`}>
                <h1 id="name">Kishan Rajagunathas</h1>
                <div className={style.menu}>
                    <Link id="home" className="pages" onClick={() => scrollTo("HeroC")}>Home</Link>
                    <Link id="edu" className="pages" onClick={() => scrollTo("EduC")}>Skills</Link>
                    <Link id="exps" className="pages" onClick={() => scrollTo("ExpC")}>Experience</Link>
                    <Link id="projs" className="pages" onClick={() => scrollTo("ProjC")}>Projects</Link>
                    <div
                        className="divice"
                        onMouseEnter={() => setShowTooltip(true)}
                        onMouseLeave={() => setShowTooltip(false)}
                        style={{ position: 'relative' }}
                    >
                        <Switch
                            className="ice"
                            onChange={themeSwitch}
                            checked={theme === 'dark'}
                            onColor="#06b6d4"
                            offColor="#f5576c"
                            onHandleColor="#FFFFFF"
                            offHandleColor="#FFFFFF"
                            height={30}
                            width={50}
                            checkedIcon = {false}
                            uncheckedIcon = {false}
                        />
                        {showTooltip && (
                            <div className={`${style.tooltip} ${theme === 'light' ? style.tooltipLight : ''}`}>
                                {theme === 'dark' ? 'Switch to Light Mode' : 'Switch to Dark Mode'}
                            </div>
                        )}
                    </div>
                </div>
                <div id={style.box}></div>
            </div>

            {showWarningModal && (
                <div className={style.modalOverlay} onClick={cancelLightMode}>
                    <div className={style.modalContent} onClick={(e) => e.stopPropagation()}>
                        <div className={style.modalHeader}>
                            <span className={style.warningIcon}>⚠️</span>
                            <h2 className={style.modalTitle}>Warning</h2>
                        </div>
                        <p className={style.modalText}>
                            You are stepping into the light. Be aware—it may be too blinding.
                            Cross of your own volition, for what awaits beyond is not meant for every eye.
                            Not everyone who seeks the light is ready to face what it reveals.
                        </p>
                        <div className={style.modalButtons}>
                            <button className={style.cancelButton} onClick={cancelLightMode}>
                                Cancel
                            </button>
                            <button className={style.confirmButton} onClick={confirmLightMode}>
                                Proceed
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default Navbar;